import { Component, Input } from '@angular/core';
import { FormlyFieldConfig } from '@ngx-formly/core';

import { ModalService } from '../../../services';

@Component({
  selector: 'app-form-ok-cancel-modal',
  templateUrl: './form-ok-cancel-modal.component.html',
  styleUrl: './form-ok-cancel-modal.component.scss',
})
export class FormOkCancelModalComponent {
  @Input() header: string;
  @Input() message: string;
  @Input() okLabel = $localize`Ok`;
  @Input() fields: FormlyFieldConfig[];
  @Input() model: any = {};

  constructor(private modalService: ModalService) {}

  onOk() {
    this.modalService.close(this.model);
  }

  onCancel() {
    this.modalService.dismiss();
  }
}
